export const useMagazineIds = () => {
  return useRuntimeConfig().public.magazineIds ? String(useRuntimeConfig().public.magazineIds).split(',') : []
}
